import gql from "graphql-tag";

export const INVOICE = gql`
  query invoice($where: InvoiceWhereInput) {
    invoice(where: $where) {
      id
      payed
      price
      invoiceLines {
        id
        quantity
        price
        item {
          id
          name
        }
      }
    }
  }
`;

export const INVOICES = gql`
  query invoices($where: InvoiceWhereInput) {
    invoices(where: $where) {
      data {
        receiptNo
        creationDate
      }
      count
    }
  }
`;
